export default "__VITE_ASSET__CLFyF$cs__"